/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DownloadControllerService {

  /**
   * Download the requested resource
   * @returns binary Resource successfully downloaded
   * @throws ApiError
   */
  public static download({
filename,
}: {
filename: string,
}): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/download',
      query: {
        'filename': filename,
      },
      errors: {
        403: `Unauthorized user`,
      },
    });
  }

}
